export const HANA_FLIGHT_URL =
  "https://trb.kei-travel.co.kr/tk/m/mypage/flight/intl/bookings/";
export const HANA_HOTEL_URL =
  "https://tb-thai.monkeytravel.com/user/mypage/booklist.php";
